module.exports = __webpack_public_path__ + "img/shortly.5ee5366c.svg";